<ui-title [title]="'QAR Browser'">

	<div class="col-lg-6 float-right">
		<ui-loading [loadingText]="'loading reports'" [loading]="reports.loading"></ui-loading>
	</div>
</ui-title>

<div class="col-lg-6">
	<ui-table
		[chunker]="reports.chunker" (chunked)="reports.chunkedData = $event"
		[headers]="reports.tableHeaders"
	>
		<tr *ngFor="let report of reports.chunkedData"
			[class]="reports.selectedId==report.Id?'helper-clickable active':'helper-clickable'"
			(click)="onReportRowClick(report)"
		>
			<td>{{report.Name}}</td>
			<td>{{report.Year}}</td>
			<td class="helper-capitalize">{{report.StatusId}}</td>
			<td>{{report.CreatedDate|date}}</td>
			<td>{{report.ClosedDate|date}}</td>
			<td ><button type="button" class="btn btn-danger btn-sm" style=" width:100%;  margin-top: -3px;
							padding-top: 8px;" (click)="delete_Report(report.Id)" >X
							</button>
		    </td>
		</tr>
	</ui-table>
</div>


<div class="col-lg-12 mt-4" *ngIf="reports.selectedId">
	<ui-loading [loadingText]="'loading report'" [loading]="report.loading"></ui-loading>

	<div *ngIf="reports.selected">
		<div class="d-flex align-items-center justify-content-between mb-2">
			<h2 class="mb-0">Report {{reports.selected.Name}} {{reports.selected.Year}}</h2>
			<div class="systems-filter" *ngIf="systemsFilter.availableSystems.length > 0">
				<button type="button" class="btn btn-outline-secondary"
					(click)="systemsFilter.open = !systemsFilter.open">
					Select Systems
					<span class="caret">&#9662;</span>
				</button>
				<div class="systems-filter-dropdown" *ngIf="systemsFilter.open">
					<div class="systems-filter-list">
						<label *ngFor="let s of systemsFilter.availableSystems" class="systems-filter-item">
							<input type="checkbox" [checked]="systemsFilter.draftSelected[s]"
								(change)="onSystemDraftToggle(s, $event.target.checked)" />
							<span>{{ s }}</span>
						</label>
					</div>
					<div class="systems-filter-actions">
						<button type="button" class="btn btn-primary btn-sm" [disabled]="!isAnySystemDraftSelected()"
							(click)="applySystemsFilter()">OK</button>
						<button type="button" class="btn btn-link btn-sm"
							(click)="cancelSystemsFilter()">Cancel</button>
					</div>
				</div>
			</div>
		</div>
		<ui-table #tableReportRows [options]="report.tableOptions" [chunker]="report.chunker"
			(chunked)="report.chunkedData = $event" [headers]="report.tableHeaders" [filters]="true">
			<tr *ngFor="let d of report.chunkedData">
				<td>{{d.SORUserOverridenApproverId ? d.SORUserOverridenApprover?.FirstName :
					d.SORUserApprover?.FirstName}}</td>
				<td>{{d.SORUserOverridenApproverId ? d.SORUserOverridenApprover?.LastName :
					d.SORUserApprover?.LastName}}</td>
				<td style="width:125px">{{report.statusDescriptions[d.StatusId]}}</td>
				<td style="width:150px"><span *ngIf="d.StatusId != 'pending'">{{d.CompletedDate|date}}</span></td>
				<td style="width:150px">{{d.CounterSignedDate|date}}</td>
				<td><a *ngIf="report_canSeeOpenReportButton(d)" [routerLink]="'/p/reports/participation/' + d.Id">Open</a></td>
			</tr>
		</ui-table>
	</div>
</div>
